'use client';

import { Text } from '@mantine/core';
import { useEffect, useState } from 'react';

type ObfuscatedEmailProps = {
  /** Base64 encoded email address for display (e.g., btoa('contact@example.com')) */
  encodedEmail: string;
  /** Base64 encoded mailto link (e.g., btoa('mailto:contact@example.com')) */
  encodedMailto: string;
};

/**
 * Client-side component that renders an obfuscated email address.
 * The email is base64 encoded and only decoded on the client side,
 * making it harder for bots to scrape the email address from the HTML source.
 */
export function ObfuscatedEmail({ encodedEmail, encodedMailto }: ObfuscatedEmailProps) {
  const [email, setEmail] = useState<string | null>(null);
  const [mailto, setMailto] = useState<string | null>(null);

  useEffect(() => {
    // Decode on client side only
    setEmail(atob(encodedEmail));
    setMailto(atob(encodedMailto));
  }, [encodedEmail, encodedMailto]);

  // Show placeholder during SSR and initial hydration
  if (!email || !mailto) {
    return (
      <Text component="span" c="blue">
        [E-Mail wird geladen...]
      </Text>
    );
  }

  return (
    <Text component="a" c="blue" href={mailto}>
      {email}
    </Text>
  );
}
